export default Object.freeze({
  items: [],
  loaded: false,
});
